import { render } from "./Recruit.vue?vue&type=template&id=4e134fb6&scoped=true"
import script from "./Recruit.vue?vue&type=script&lang=js"
export * from "./Recruit.vue?vue&type=script&lang=js"

import "./Recruit.vue?vue&type=style&index=0&id=4e134fb6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rights.tokyo/rights.tokyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e134fb6"]])

export default __exports__